import { create } from 'zustand'

import { AppMenuSavedDashboardInterface } from 'src/types/AppMenuInterface'
import { ReactCallBackFunction } from 'src/types/CallbackFunction'

interface SelectedDashboardState {
  selectedDashboard: AppMenuSavedDashboardInterface | null
  setSelectedDashboard: ReactCallBackFunction<AppMenuSavedDashboardInterface | null>
}

const useSelectedDashboardStore = create<SelectedDashboardState>(set => ({
  selectedDashboard: null,
  setSelectedDashboard: dashboard =>
    set(s => ({
      ...s,
      selectedDashboard:
        typeof dashboard === 'function' ? dashboard(s.selectedDashboard) : dashboard,
    })),
}))

export default useSelectedDashboardStore
